module.exports = __webpack_public_path__ + "static/media/logo-esrc-festival.34d28de3.jpg";